import { cn } from "@/lib/utils";
import { TONE_STYLES } from "@/lib/colors";
import { PROSPECT_STATUS_LABELS, PROSPECT_STATUS_TONE } from "@shared/labels";
import type { ProspectStatus } from "@shared/schema";

export function StatusPill({
  status,
  className,
}: {
  status: ProspectStatus;
  className?: string;
}) {
  const tone = TONE_STYLES[PROSPECT_STATUS_TONE[status]];
  return (
    <span className={cn("pill", tone.pillBg, tone.pillFg, className)}>
      <span className={cn("pill-dot", tone.dot)} />
      {PROSPECT_STATUS_LABELS[status]}
    </span>
  );
}
